import { render } from "./formEditEnquete.vue?vue&type=template&id=fbe0fa36"
import script from "./formEditEnquete.vue?vue&type=script&lang=js"
export * from "./formEditEnquete.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__